import React from 'react';

function ContentPublic({ children }) {
    return (
        <div className="content-wrapper">
            {children}
        </div>
    );
}

export default ContentPublic;
